import * as Anchors from 'components/anchors'
import ButtonStyles from 'components/button/Button.module.css'
import { FormattedMessage } from 'react-intl'

export function ContactUs({ subject, body }) {
    return (
        <Anchors.Mailto subject={subject} body={body} className={ButtonStyles.Primary}>
            <FormattedMessage id="contact-us" defaultMessage="Contact us" />
        </Anchors.Mailto>
    )
}
